import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'


export default function CheckLogin() {
    const navigate=useNavigate()
   
  useEffect(() => {
   if(!sessionStorage.getItem('userid')){
navigate('/login');
   }else{
   
   }
  }, [])
  
}
